import React from 'react'
import PropTypes from 'prop-types'

import FilterGroup from '@components/FilterGroup'
import { Dropdown } from '@components/Autocomplete'
import { clientRecords } from '@atheneum/api'

class AccountFilter extends React.Component {
  state = {
    accounts: []
  }

  static propTypes = {
    parentAccountId: PropTypes.number,
    projectsListingStore: PropTypes.object
  }

  componentDidMount () {
    return clientRecords
      .getAccounts(this.props.parentAccountId, { expanded: false })
      .then(accounts => {
        this.setState({
          accounts: accounts.map(({ id, companyName }) => ({
            value: id,
            label: companyName
          }))
        })
      })
  }

  render () {
    const { projectsListingStore } = this.props
    const { query, filter } = projectsListingStore
    return (
      <FilterGroup inView label='Accounts' labelClass='code-label'>
        <Dropdown
          options={[{ value: 0, label: 'All' }].concat(this.state.accounts)}
          selectedItem={projectsListingStore.accountSuggestion}
          itemToString={item => item && item.label}
          onChange={account => {
            query.accountId = account.value
            projectsListingStore.accountSuggestion = account
            filter()
          }}
        />
      </FilterGroup>
    )
  }
}

export default AccountFilter
